import type { SessionDataType } from '@confluence/session-data';

// Preload function context is a subset of session data
// It's a subset because we can't provide everything on the server-side.
export type PreloadFnContext = {
	isLoggedIn: SessionDataType['isLoggedIn'];
	/**
	 * @deprecated Use accessStatus
	 */
	isLicensed: SessionDataType['isLicensed'];
	accessStatus: SessionDataType['accessStatus'];
	userId: SessionDataType['userId'];
	cloudId: SessionDataType['cloudId'];
	orgId: SessionDataType['orgId'];
	/**
	 * @deprecated Use `fg()` from `@confluence/feature-gating`;
	 */
	featureFlags: SessionDataType['featureFlags'];
	edition: SessionDataType['edition'];
	activationId: SessionDataType['activationId'];
	environment: SessionDataType['environment'];
	locale: SessionDataType['locale'];
	isAdminHubAIEnabled: SessionDataType['isAdminHubAIEnabled'];
	isRovoEnabled: SessionDataType['isRovoEnabled'];
	isRovoLLMEnabled: SessionDataType['isRovoLLMEnabled'];
};

function sessionDataLikeToPreloadFnContext(data: Partial<SessionDataType>): PreloadFnContext {
	return {
		isLoggedIn: Boolean(data.isLoggedIn),
		isLicensed: Boolean(data.isLicensed),
		accessStatus: data.accessStatus || null,
		userId: data.userId || null,
		cloudId: data.cloudId || '',
		orgId: data.orgId,
		featureFlags: data.featureFlags || {},
		edition: data.edition || null,
		activationId: data.activationId || '',
		environment: data.environment || 'PRODUCTION',
		// Note: the locale from session data is not standard aa-AA format. It is aa_AA
		locale: data.locale?.replace('_', '-') || 'en-US',
		isAdminHubAIEnabled: Boolean(data.isAdminHubAIEnabled),
		isRovoEnabled: Boolean(data.isRovoEnabled),
		isRovoLLMEnabled: Boolean(data.isRovoLLMEnabled),
	};
}

export type getPreloadFnContextType = () => Promise<PreloadFnContext>;

let resolveContext = (_: PreloadFnContext) => {};
const contextPromise: Promise<PreloadFnContext> = new Promise(
	(resolve) => (resolveContext = resolve),
);

export function initializePreloaderFnContext(context: PreloadFnContext) {
	resolveContext(sessionDataLikeToPreloadFnContext(context));
}

export async function getPreloaderFnContext(): Promise<PreloadFnContext> {
	return contextPromise;
}
